import * as React from 'react'
import { ChampionIcon } from './champion-icon'

import { cn } from '@/lib/utils'

import type {
  BracketDirection,
  BracketMakerCopy,
  BracketTheme,
  ChampionPlacement,
} from './types'

type ChampionNodeProps = {
  champion: string
  copy: BracketMakerCopy
  direction: BracketDirection
  placement: ChampionPlacement
  showNames: boolean
  style?: React.CSSProperties
  theme: BracketTheme
}

export function ChampionNode({
  champion,
  copy,
  direction,
  placement,
  showNames,
  style,
  theme,
}: ChampionNodeProps) {
  const nodeStyle =
    direction === 'horizontal'
      ? {
          gridColumnStart: placement.columnIndex,
          gridRowStart: placement.rowStart,
          gridRowEnd: placement.rowEnd,
        }
      : style

  return (
    <div
      style={nodeStyle}
      className={cn(
        'flex h-full w-full items-center justify-center',
        direction === 'vertical' ? 'absolute' : 'relative',
      )}
    >
      <div className={theme.championCard}>
        <ChampionIcon />
        <span className={theme.championBadge}>{copy.champion}</span>
        <p className="line-clamp-2 text-sm font-semibold leading-tight">
          {showNames && champion ? champion : copy.champion}
        </p>
      </div>
    </div>
  )
}
